export enum BlockContentContext {
  Article = 'article',
  ProductArticle = 'productArticle',
  Stripped = 'stripped',
}
